import { useSyncExternalStore } from 'react';
import { diagramStore } from '../state/diagramStore';

export function useDiagram() {
  return useSyncExternalStore(
    (cb) => diagramStore.subscribe(cb),
    () => diagramStore.getSnapshot(),
    () => diagramStore.getSnapshot(),
  );
}

export function useDiagramVersions() {
  return useSyncExternalStore(
    (cb) => diagramStore.subscribe(cb),
    () => diagramStore.getVersions(),
    () => diagramStore.getVersions(),
  );
}
